package io.horion.cv.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class FormationState(
    val id: String,
     formation: String = "",
     etablissement: String = "",
     ville: String = "",
     moisDebut: String = "",
     anneeDebut: String = "",
     moisFin: String = "",
     anneeFin: String = "",
     isOngoing: Boolean = false,
     description: String = ""
) {
    var formation by mutableStateOf(formation)
    var etablissement by mutableStateOf(etablissement)
    var ville by mutableStateOf(ville)
    var moisDebut by mutableStateOf(moisDebut)
    var anneeDebut by mutableStateOf(anneeDebut)
    var moisFin by mutableStateOf(moisFin)
    var anneeFin by mutableStateOf(anneeFin)
    var isOngoing by mutableStateOf(isOngoing)
    var description by mutableStateOf(description)
}
